/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsDigitizingPositionListItem,
    DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSON,
    DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsDigitizingPositionListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsDigitizingPositionListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsDigitizingPositionListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingPositionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


